export default function isAdmin() {
  const role = localStorage.getItem("user.role");
  // console.log("role is role", role)
  if (role === "admin") return true;
  return false;
}
